import { Button, Icon } from "@chakra-ui/react";
import { FcGoogle } from "react-icons/fc";
import { SignInStyles } from "../hooks/useSignInStyles";

interface GoogleLoginButtonProps {
  authStyles: any;
  styles: SignInStyles;
  isLoading: boolean;
  onClick: () => void;
}

export function GoogleLoginButton({ authStyles, styles, isLoading, onClick }: GoogleLoginButtonProps) {
  return (
    <Button
      py={authStyles.button?.google?.py || "15px"}
      px={authStyles.button?.google?.px || "30px"}
      height={"48px"}
      fontSize={"16px"}
      fontWeight="400"
      borderRadius="12px"
      bg="#fff"
      color="#0B0E10"
      border="1px solid #E6ECF3"
      onClick={onClick}
      _hover={{}}
      _focus={{ borderColor: "#3A7BFF" }}
      _active={{ borderColor: "#3A7BFF" }}
    >
      Login with
      <Icon as={FcGoogle} w="20px" h="20px" me="10px" ml="10px" />
    </Button>
  );
}
